import styled from 'styled-components';

export const WrapperDiv = styled.div<{ position: string }>`
  display: flex;
  flex-direction: ${(props) =>
    props.position === 'left' ? 'row-reverse' : 'row'};
  align-items: center;
  justify-content: flex-start;
`;

export const TextDiv = styled.div<{
  size: string;
  greyText: boolean;
}>`
  font-size: ${(props) => props.size};
  font-weight: 700;
  color: ${(props) =>
    props.greyText ? props.theme.palette.text.secondary : props.color};
  display: flex;
`;

export const HelperText = styled.div<{ color?: string }>`
  color: ${(props) => props.color ?? props.theme.palette.text.secondary};
  margin-left: 8px;
`;
